import { AppBuilder, EVENTS, WIRES } from '@empathybroker/ebx-gluon';

export const wiringConfiguration = (appBuilder: AppBuilder) => {
  appBuilder
    .addWireToEvent(WIRES.blurSearchInput, EVENTS.Scroll)
    .addWireToEvent(WIRES.toggleSortList, EVENTS.SortClicked)
    .removeWireFromAllEvents(location.href.includes('aprendeymejora') ? WIRES.loadPreselectedFilters : () => {});
};

